import { gql } from '@src/lib/gql'

/** Clarity link plan (D2): email a one-time code to the Clarity account's own address. */
export const REQUEST_CLARITY_LINK_CODE = gql`
  mutation RequestClarityLinkCode($input: RequestClarityLinkCodeInput!) {
    requestClarityLinkCode(input: $input) {
      proofMethod
      maskedEmail
      expiresAt
      alreadyLinked
    }
  }
`

/** D8: admin link without the email proof. `reassign` moves the member from its current holder. */
export const ADMIN_LINK_CLARITY_ACCOUNT = gql`
  mutation AdminLinkClarityAccount($input: AdminLinkClarityAccountInput!) {
    adminLinkClarityAccount(input: $input) {
      user {
        id
        userId
        linkedAccounts {
          id
          app
          externalUserId
        }
      }
      reviewSync {
        fetchedCount
        createdCount
        updatedCount
        restoredCount
        unchangedCount
        removedCount
        skippedCount
        syncedAt
      }
      reviewSyncError
    }
  }
`

/** D7/D8: admin-only unlink. Also removes the member's imported Clarity reviews. */
export const ADMIN_UNLINK_CLARITY_ACCOUNT = gql`
  mutation AdminUnlinkClarityAccount($input: AdminUnlinkClarityAccountInput!) {
    adminUnlinkClarityAccount(input: $input) {
      user {
        id
        userId
        linkedAccounts {
          id
          app
          externalUserId
        }
      }
      unlinkedCount
      removedReviewCount
      removedDuplicateLinkCount
    }
  }
`
